import { isDefined } from '../../utils/variables';

export const getFileExtension = (fileName: string): string => {
  // Extract basename (last path segment), supporting POSIX and Windows separators
  const lastSep = Math.max(fileName.lastIndexOf('/'), fileName.lastIndexOf('\\'));
  const base = fileName.slice(lastSep + 1);
  const lastDotIndex = base.lastIndexOf('.');
  if (lastDotIndex <= 0) {
    return '';
  }
  return base.slice(lastDotIndex);
};

// Polyfill for Node's path.basename with optional extension stripping.
// Handles both POSIX and Windows separators.
export const getFileBaseName = (filePath: string, ext?: string): string => {
  if (!filePath) {
    return '';
  }

  const trimmedPath = filePath.replace(/[\\/]+$/, ''); // drop trailing separators
  const lastSeparatorIndex = Math.max(trimmedPath.lastIndexOf('/'), trimmedPath.lastIndexOf('\\'));
  const fileName = trimmedPath.slice(lastSeparatorIndex + 1);

  if (!isDefined(ext)) {
    return fileName;
  }

  const normalizedExt = ext.toLowerCase();
  const normalizedFileName = fileName.toLowerCase();

  if (normalizedExt && normalizedFileName.endsWith(normalizedExt)) {
    return fileName.slice(0, fileName.length - normalizedExt.length);
  }

  return fileName;
};

/**
 * Polyfill for Node's path.dirname.
 * Returns the directory name of a path (parent path). Handles both POSIX and Windows separators.
 * @example getDirname('/foo/bar/baz') => '/foo/bar'; getDirname('foo/bar') => 'foo'; getDirname('bar') => '.'
 */
export const getDirname = (filePath: string): string => {
  if (!filePath) {
    return '';
  }
  const trimmedPath = filePath.replace(/[\\/]+$/, '');
  const lastSep = Math.max(trimmedPath.lastIndexOf('/'), trimmedPath.lastIndexOf('\\'));
  if (lastSep < 0) {
    return '.';
  }
  if (lastSep === 0) {
    return trimmedPath.length > 1 ? trimmedPath.slice(0, 1) : trimmedPath;
  }
  return trimmedPath.slice(0, lastSep);
};
